<template>
    <div></div>
</template>

<script>
export default {
    mounted() {
        console.log(performance.now());
    },
    created() {
        console.log(performance.now());
    },
};
</script>

<style lang="scss" scoped>
</style>